export default __webpack_public_path__ + "static/media/ENGLISH_PHONICS.5104aaf2.svg";